import React from 'react';
import { shape, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';

import config from '../../config';
import css from './SectionRulesMaybe.module.css';

// These dates are stored by EditListingDescriptionPanel as `date.toString()`, i.e. an
// INSTANT carrying the host's own UTC offset ("Wed May 05 2027 00:00:00 GMT+0200"), not a
// calendar date. So the timezone we render in decides which day is shown:
//   - viewer's timezone  -> shifts a day back for anyone west of the host
//                           (Berlin midnight is 22:00 UTC the previous day)
//   - UTC                -> shifts a day back for EVERY German-created listing
// Pinning to the event's own timezone is what gives back the date the host actually picked.
// The locale was previously unset too, so the format followed the visitor's browser
// (an en-US browser rendered the German-only site's dates as "5/9/2027").
const EVENT_TIME_ZONE = 'Europe/Berlin';
const DATE_FORMAT = {
  timeZone: EVENT_TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

const formatEventDate = value => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date.toLocaleDateString(config.locale, DATE_FORMAT);
};

const SectionRulesMaybe = props => {
  const { className, rootClassName, publicData } = props;
  const classes = classNames(rootClassName || css.root, className);

  const availableFrom = formatEventDate(publicData.availableFrom?.date ?? publicData.availableFrom);
  const availableUntil = formatEventDate(
    publicData.availableUntil?.date ?? publicData.availableUntil
  );

  const isOffering = publicData?.category === 'offeringPlace';
  const isLooking = publicData && publicData.category === 'lookingForPlace';
  const privatquartier = publicData && publicData.type === 'privatquartier';

  const language = publicData.language;
  const capacity = publicData.capacityNumberOfPeople;
  const size = publicData.size;
  const pets = publicData.pets && publicData.pets === 'yes';
  const petsNotAllowed = publicData.pets && publicData.pets === 'no';
  const petsInfo = publicData.petsInfo;
  const accessibility =
    Array.isArray(publicData.accessibility) && publicData.accessibility[0] === 'yes';
  const accessibilityInfo = publicData.accessibilityInfo;
  const noAccessibility =
    Array.isArray(publicData.accessibility) && publicData.accessibility[0] === 'no';

  const assistanceAnimals =
    Array.isArray(publicData.assistanceAnimals) && publicData.assistanceAnimals[0] === 'yes';
  const assistanceAnimalsNotAlloed =
    Array.isArray(publicData.assistanceAnimals) && publicData.assistanceAnimals[0] === 'no';
  const assistanceAnimalsInfo = publicData.assistanceAnimalsInfo;

  const allergies = publicData.allergies && publicData.allergies === 'yes';
  const noAllergies = publicData.allergies && publicData.allergies === 'no';
  const allergiesInfo = publicData.allergiesInfo;

  return (
    <div className={classes}>
      <h2 className={css.title}>
        <FormattedMessage id="ListingPage.rulesTitle" />
      </h2>
      <p className={css.info}>
        <strong>
          {isLooking ? "Suche ab:" : "Verfügbar ab:"}
        </strong>
        {availableFrom}
      </p>

      <p className={css.info}>
        <strong>
          {isLooking ? "Suche bis:" : "Verfügbar bis:"}
        </strong>
        {availableUntil}
      </p>

      {!privatquartier && size &&
        <p className={css.info}>
          <strong>{isLooking ? 'Mindestgröße:' : 'Stellplatzgröße:'}</strong>
          {size}
        </p>
      }

      {language &&
        <p className={css.info}>
          <strong>{isOffering ? 'Sprache(n) des Gastgebers:' : 'Sprache(n) des Gastes:'}</strong>
          {language}
        </p>
      }

      {privatquartier && capacity &&
        <p className={css.info}>
          <strong>
            {isLooking ? "Gästeanzahl:" : "Gästekapazität:"}
          </strong>
          {capacity}
        </p>
      }

      {privatquartier && accessibility && accessibilityInfo &&
        <p className={css.info}>
          <strong>Barrierefreiheit:</strong>
          {accessibilityInfo}
        </p>
      }

      {privatquartier && noAccessibility &&
        <p className={css.info}>
          <strong>Barrierefreiheit:</strong>
          {isLooking ? "Nicht benötigt" : "Nicht barrierefrei"}
        </p>
      }

      {privatquartier && isLooking && assistanceAnimals && assistanceAnimalsInfo &&
        <p className={css.info}>
          <strong>
            Assistenztiere:
          </strong>
          {assistanceAnimalsInfo}
        </p>
      }

      {privatquartier && isLooking && assistanceAnimalsNotAlloed &&
        <p className={css.info}>
          <strong>
            Assistenztiere:
          </strong>
          Nicht vorhanden
        </p>
      }

      {privatquartier && isOffering && pets && petsInfo &&
        <p className={css.info}>
          <strong>Haustiere:</strong>
          {petsInfo}
        </p>
      }

      {privatquartier && isOffering && petsNotAllowed &&
        <p className={css.info}>
          <strong>Haustiere:</strong>
          Nicht vorhanden
        </p>
      }

      {privatquartier && isLooking && allergies && allergiesInfo &&
        <p className={css.info}>
          <strong>Allergien:</strong>
          {allergiesInfo}
        </p>
      }

      {privatquartier && isLooking && noAllergies &&
        <p className={css.info}>
          <strong>Allergien:</strong>
          Nicht vorhanden
        </p>
      }
    </div >
  );

  // return publicData && publicData.rules ? (
  //   <div className={classes}>
  //     <h2 className={css.title}>
  //       <FormattedMessage id="ListingPage.rulesTitle" />
  //     </h2>
  //     <p className={css.rules}>{publicData.rules}</p>
  //   </div>
  // ) : null;
};

SectionRulesMaybe.defaultProps = { className: null, rootClassName: null };

SectionRulesMaybe.propTypes = {
  className: string,
  rootClassName: string,
};

export default SectionRulesMaybe;
